import { Box, Divider, Drawer, Stack, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { CohortSummaryDetails, CohortSummaryAttributeResult } from '@verantos-dev/types-cohorts';

import { CohortCharacteristicsDataDialogTitle } from './CohortCharacteristicsDataDialogTitle';
import CohortCharacteristicsTabularData from './CohortCharacteristicsTabularData';

type CohortCharacteristicsDataDialogProps = {
  totalSubjectCount: number;
  cohortSummaryData: CohortSummaryDetails;
  onHideDataDialog: () => void;
  clinicalCharacteristicsDomainType?: string;
  selectedCharacteristicType?: string;
  customDisplayData?: CohortSummaryAttributeResult[];
  hasAnyCustomSelection?: boolean;
};

export const CohortCharacteristicsDataDialog = ({
  totalSubjectCount,
  cohortSummaryData,
  onHideDataDialog,
  clinicalCharacteristicsDomainType,
  selectedCharacteristicType,
  customDisplayData,
  hasAnyCustomSelection,
}: CohortCharacteristicsDataDialogProps) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={true}
      onClose={onHideDataDialog}
      PaperProps={{
        sx: {
          height: '100vh', // Full height of the browser window
          width: '476px',
        },
      }}
    >
      <CohortCharacteristicsDataDialogTitle
        onHideDataDialog={onHideDataDialog}
        selectedCharacteristicType={selectedCharacteristicType || ''}
      />
      <Box
        data-testid="cohortCharacteristicsTabularData"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          alignSelf: 'stretch',
          borderRadius: '4px',
          border: `1px solid  ${theme.palette.divider}`,
          width: '428px',
          mx: 6,
          mb: 6,
          overflow: 'scroll',
        }}
      >
        <Box sx={{ width: '100%', height: '100%' }}>
          {/* column header */}
          <Stack direction="row" justifyContent="space-between" sx={{ px: '14px', py: '14px' }}>
            <Typography variant="body1" fontWeight="500" color={theme.palette.text.primary}>
              {intl.formatMessage({
                id: 'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.columnLabel',
              })}
            </Typography>
            <Typography variant="body1" fontWeight="500" color={theme.palette.text.primary}>
              {`N = ${totalSubjectCount.toLocaleString()}`}
            </Typography>
          </Stack>
          <Divider />
          <CohortCharacteristicsTabularData
            cohortSummaryData={cohortSummaryData}
            clinicalCharacteristicsDomainType={clinicalCharacteristicsDomainType}
            customDisplayData={customDisplayData}
            hasAnyCustomSelection={hasAnyCustomSelection}
          />
        </Box>
      </Box>
    </Drawer>
  );
};
